module.exports = __webpack_public_path__ + "static/img/roleList.0221019f.png";